import React from "react";
import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const CustomBreadcrumbs = ({ items, currentLabel }) => {
  const navigate = useNavigate();

  const handleBreadcrumbClick = (path) => {
    navigate(path);
  };

  // Ensure currentLabel is always treated as an array
  const labels = Array.isArray(currentLabel) ? currentLabel : [currentLabel];

  return (
    <Box m={3}>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
      >
        {items.map((item, index) => (
          <Link
            key={index}
            underline="hover"
            onClick={() => handleBreadcrumbClick(item.path)}
            style={{ cursor: "pointer", fontWeight: "bold" }}
          >
            {item.label}
          </Link>
        ))}
        {labels.map((label, index) => (
          <Typography key={index} color="text.secondary">
            {label}
          </Typography>
        ))}
      </Breadcrumbs>
    </Box>
  );
};

export default CustomBreadcrumbs;
